import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ITerminalStatusResponse } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets the terminal status based upon the logged in users privileges
 * 
 * @returns {object} the terminal status
 */
const GetDispenserHeartBeat = async (): Promise<ITerminalStatusResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId, accessLevel, accessList } = useAuth()!;

    const partnerIdList = accessList.map((element: any) => `'${element.id}'`).join(',');

    const { data } = await awsApiInstance.get('/terminal/status', {
      params: {
        wpId: userId,
        accessLevel,
        accessList: partnerIdList
      }
    });
    
    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting terminal status data');
    throw(error);
  }
}

export default GetDispenserHeartBeat;